import menuRoutes from "./route.menu.js";
// 不需要鉴权的业务路由
const commonRoutes = [
  
  ...menuRoutes,
];
export default commonRoutes;
